import { VenueFlags } from 'core/entities';
import { ReactElement } from 'react';
import { PlaceWithFilters } from 'features/insights/store/poi/poi-types';
import { NearbyActivityOption } from './explore-drawer-option/options/nearby-report-option';
import { EnclosedPoiOption } from './explore-drawer-option/options/enclosed-poi-option';
import { VerifiedReportOption } from './explore-drawer-option/options/verified-report-option';
import { PointOfInterestFilters } from 'core/entities/point-of-interest-entities';
import { MarketInPropertyReport } from 'features/explore/components/explore-side-bar/components/explore-drawer/explore-drawer-option/options/market-in-property-report';

export type ReportOptionKey = 'property' | 'nearby_activity' | 'market' | 'enclosed_poi' | 'chain';

export type POIActionProps = {
    poi: PointOfInterestFilters;
    enclosingComplex?: PlaceWithFilters[];
    enableSelection?: boolean;
    enforceOpenPropertyReport?: boolean;
    value: ReportOptionKey;
};

type ReportOption = {
    Component: ({ poi, enclosingComplex }: POIActionProps) => ReactElement;
    value: ReportOptionKey;
};

const verifiedReportOption: ReportOption = {
    Component: VerifiedReportOption,
    value: 'property',
};

const nearbyActivityOption: ReportOption = {
    Component: NearbyActivityOption,
    value: 'nearby_activity',
};

const marketInPropertyReportOption: ReportOption = {
    Component: MarketInPropertyReport,
    value: 'market',
};

const enclosedPoiOption: ReportOption = {
    Component: EnclosedPoiOption,
    value: 'enclosed_poi',
};

const limitedVenueOptions = [nearbyActivityOption];
const enclosedVenueOptions = [enclosedPoiOption];

export const DrawerOptions: Record<VenueFlags | 'default' | 'markets', ReportOption[]> = {
    indoor: enclosedVenueOptions,
    multi_story: enclosedVenueOptions,
    unusual_visit_volume: limitedVenueOptions,
    nearby_activity: limitedVenueOptions,
    dense_area: limitedVenueOptions,
    privacy_concerns: [],
    privacy_policy: [],
    not_available: [],
    unknown_flag: limitedVenueOptions,
    default: [verifiedReportOption, nearbyActivityOption],
    markets: [verifiedReportOption, marketInPropertyReportOption],
    low_panel: [],
};
